<div id="dashboard-project" class="page-layout simple right-sidebar" fxLayout="row">

  <!-- CENTER -->
  <div class="center" fusePerfectScrollbar>

    <!-- HEADER -->
    <div class="header"
         [style.color]="'var(--modules-theme-' + moduleName + '-text-color)'"
         [style.background-image]="'var(--modules-theme-' + moduleName + '-background-image)'"
         [style.background-color]="'var(--modules-theme-' + moduleName + '-background-color)'">
      <div class="p-24 pb-0 h-100-p" fxLayout="column" fxLayoutAlign="end">

        <div fxLayout="row" fxLayoutAlign="space-between start">

                <h1 class="mat-display-1 my-0 my-sm-24 welcome-message p-4 pr-20"
                      [style.background-color]="'var(--modules-theme-' + moduleName + '-background-color)'"
                      [style.display]="'var(--modules-theme-' + moduleName + '-hide-text)'"
                      [@animate]="{value:'*',params:{x:'50px'}}"
                      [style.color]="'var(--theme-primary-color-50)'">
                  {{'MODULES.' + moduleName + '.TITLE' | translate}}
                </h1>

        </div>

      </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content">

      <router-outlet></router-outlet>

    </div>
    <!-- / CONTENT -->

  </div>
</div>
